import { Colors, Icon, type ListItemData } from '@amelio/ui-library';
import { useMemo } from 'react';

import {
    ANONYMOUS_FEEDBACK_MINIMUM_RESPONSES,
    isAnonymousFeedback,
    type FeedbackPrivacyValue,
} from '@/constants/review/FeedbackPrivacy';
import { useAmelioTranslations } from '@/hooks';

/**
 * What the manager will read of the results, as the launch summary tells it: everything of a named
 * feedback, and of an anonymous one never an individual answer.
 */
export const useManagerAccessList = (feedbackPrivacy?: FeedbackPrivacyValue): ListItemData[] => {
    const { t } = useAmelioTranslations();

    return useMemo(() => {
        const checked = (content: string): ListItemData => ({
            content,
            icon: (
                <Icon
                    name={'essential-checkmark'}
                    color={Colors.PRIMARY}
                />
            ),
        });

        return [
            checked(t('evaluation360ScheduleCreation.resultsVisibility.viewAllScore')),
            checked(t('evaluation360ScheduleCreation.resultsVisibility.readAllComments')),
            isAnonymousFeedback(feedbackPrivacy)
                ? {
                      content: t(
                          'evaluation360ScheduleCreation.resultsVisibility.noIndividualAnswer',
                          {
                              minimum: ANONYMOUS_FEEDBACK_MINIMUM_RESPONSES,
                          },
                      ),
                      icon: (
                          <Icon
                              name={'security-eye-slash'}
                              color={Colors.PRIMARY}
                          />
                      ),
                  }
                : checked(t('evaluation360ScheduleCreation.resultsVisibility.accessIndividual')),
        ];
    }, [feedbackPrivacy, t]);
};
